var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBankingAndPaymentsTransactionStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-4262.000000, -1911.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-banking-and-payments/Transaction-status",
    transform: "translate(4262.000000, 1911.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,16.0005038 L21.084,5 C19.528,6.4711675 19.528,8.85425732 21.084,10.3244172 L26.717,16.0005038 L21.084,21.6765905 C19.528,23.1467503 19.528,25.5308478 21.084,27 L32,16.0005038 Z M22.042,16.0005038 L11.125,5 C9.569,6.4711675 9.569,8.85425732 11.125,10.3244172 L16.758,16.0005038 L11.125,21.6765905 C9.569,23.1467503 9.569,25.5308478 11.125,27 L22.042,16.0005038 Z M1.167,27 C-0.389,25.5308478 -0.389,23.1467503 1.167,21.6765905 L6.799,16.0005038 L1.167,10.3244172 C-0.389,8.85425732 -0.389,6.4711675 1.167,5 L12.083,16.0005038 L1.167,27 Z",
    id: 93
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBankingAndPaymentsTransactionStatus);
export default __webpack_public_path__ + "static/media/home-banking-and-payments-transaction-status.3495c1a4.svg";
export { ForwardRef as ReactComponent };